import React, { createContext, useState, useEffect } from "react";
import { AuthContextType } from "./types";

export const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [token, setToken] = useState<string | null>(localStorage.getItem("token"));
  const [id, setId] = useState<string | null>(localStorage.getItem("id"));
  const [privilege, setPrivilege] = useState<number | null>(() => {
    const stored = localStorage.getItem("privilege");
    return stored ? parseInt(stored) : null;
  });
  const [seeGuide, setSeeGuide] = useState<boolean | null>(() => {
    const storedGuide = localStorage.getItem("seeGuide");
    return storedGuide !== null ? storedGuide === 'true': null;
  });

  useEffect(() => {
    if (token) {
      localStorage.setItem("token", token);
    } else {
      localStorage.removeItem("token");
    }

    if (id) {
      localStorage.setItem("id", id);
    } else {
      localStorage.removeItem("id");
    }

    if (privilege !== null) {
      localStorage.setItem("privilege", String(privilege));
    } else {
      localStorage.removeItem("privilege");
    }

    if (seeGuide !== null) {
      localStorage.setItem("seeGuide", String(seeGuide));
    } else {
      localStorage.removeItem("seeGuide")
    }
  }, [token, id, privilege, seeGuide]);

  const login = (newToken: string, userId: string, userPrivilege?: number, seeGuide?: boolean) => {
    setToken(newToken);
    setId(userId);

    if (userPrivilege !== undefined) {
      setPrivilege(userPrivilege);
      localStorage.setItem("privilege", String(userPrivilege));
    } else {
      setPrivilege(null);
      localStorage.removeItem("privilege");
    }

    if (seeGuide !== undefined) {
      setSeeGuide(seeGuide);
      localStorage.setItem("seeGuide", String(seeGuide));  
    } else {
      setSeeGuide(null);
      localStorage.removeItem("seeGuide")
    }

    localStorage.setItem("token", newToken);
    localStorage.setItem("id", userId);
  };

  const logout = () => {
    setToken(null);
    setId(null);
    setPrivilege(null);
    setSeeGuide(null);
    localStorage.removeItem("token");
    localStorage.removeItem("id");
    localStorage.removeItem("privilege");
    localStorage.removeItem("seeGuide")
  };

  return (
    <AuthContext.Provider value={{ token, id, privilege, seeGuide, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
